export const HOME_TITLE_MARKUP: JSX.Element = (
  <>
    The&nbsp;Right&nbsp;Vibes and&nbsp;Legal&nbsp;Compliance
    with&nbsp;Background&nbsp;Music
  </>
)
export const HOME_TITLE_MARKUP_FR: JSX.Element = (
  <>
    Une&nbsp;bonne ambiance&nbsp;et&nbsp;le respect&nbsp;du droit&nbsp;d'auteur
  </>
)
export const HOME_TITLE_MARKUP_ES: JSX.Element = (
  <>
    La&nbsp;sensación adecuada&nbsp;y&nbsp;el cumplimiento&nbsp;legal
    con&nbsp;la&nbsp;música de&nbsp;fondo
  </>
)
export const HOME_TITLE_MARKUP_KO: JSX.Element = (
  <>
    <span aria-hidden={true} className={'atb'}>
      배경음악과
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      함께
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      좋은
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      분위기와
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      법규
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      준수
    </span>
  </>
)

export const HOME_TITLE_MARKUP_STR: string =
  'The Right Vibes and Legal Compliance with Background Music'
export const HOME_TITLE_MARKUP_STR_ES: string =
  'La Sensación Adecuada y el Cumplimiento Legal con la Música de Fondo'
export const HOME_TITLE_MARKUP_STR_FR: string =
  "Une Bonne Ambiance et le Respect du Droit d'Auteur"
export const HOME_TITLE_MARKUP_STR_KO: string =
  '배경음악과 함께 좋은 분위기와 법규 준수'
